import type { CurrentUser } from '@btsis/contracts';
import type { QueryClient } from '@tanstack/react-query';

export const ME_KEY = ['auth', 'me'] as const;

function isTheSignedInUser(queryKey: readonly unknown[]): boolean {
  return queryKey[0] === ME_KEY[0] && queryKey[1] === ME_KEY[1] && queryKey.length === 2;
}

/**
 * Revealing or hiding names changes what every cached answer says. A refetch of the
 * *active* queries is not enough: an inactive one keeps its last answer, real names
 * included, until something mounts it again. So every query but the signed-in user
 * is reset — its data dropped, and refetched where a screen is showing it — and the
 * user is replaced by the answer the server gave (docs/decisions/0136).
 */
export async function forgetEveryNameExceptMe(
  queryClient: QueryClient,
  user: CurrentUser,
): Promise<void> {
  queryClient.setQueryData(ME_KEY, user);
  await queryClient.resetQueries({ predicate: (query) => !isTheSignedInUser(query.queryKey) });
}
